


import React from 'react';
import { motion } from 'framer-motion'; // ✅ Correct import
import { useInView } from 'react-intersection-observer';
import { Smartphone, Monitor } from 'lucide-react';

const CardModels = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <section
      style={{
        padding: '80px 16px',
        maxWidth: '100%',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
        {/* Heading */}
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          style={{ textAlign: 'center', marginBottom: '64px' }}
        >
          <h2
            style={{
              fontSize: '2rem',
              fontWeight: '700',
              marginBottom: '16px',
              lineHeight: 1.2,
            }}
          >
            Card{' '}
            <span
              style={{
                background: 'linear-gradient(to right, #7f5af0, #fba229)',
                WebkitBackgroundClip: 'text',
                color: 'transparent',
              }}
            >
              Models Showcase
            </span>
          </h2>
          <p style={{ fontSize: '1.125rem', color: '#888888' }}>
            Vertical and horizontal layouts for every preference
          </p>
        </motion.div>

        {/* Cards Grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '32px',
          }}
        >
          {/* Vertical Card */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ delay: 0.2, duration: 0.8 }}
            whileHover={{ scale: 1.05, rotateY: 5 }}
            style={{ transformStyle: 'preserve-3d' }}
          >
            <div
              style={{
                position: 'relative',
                borderRadius: '24px',
                overflow: 'hidden',
                border: '1px solid #e5e7eb',
                boxShadow: '0 25px 50px rgba(0,0,0,0.1)',
                background: 'linear-gradient(to bottom right, #f8fafc, #e5e7eb)',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(to bottom right, rgba(127,90,240,0.1), rgba(251,162,41,0.1))',
                  opacity: 0,
                  transition: 'opacity 0.3s',
                }}
              />
              <div style={{ padding: '32px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
                  <Smartphone style={{ width: '24px', height: '24px', color: '#7f5af0' }} />
                  <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#111827' }}>Vertical Card</h3>
                </div>

                <div
                  style={{
                    backgroundColor: 'rgba(255,255,255,0.5)',
                    backdropFilter: 'blur(4px)',
                    borderRadius: '16px',
                    padding: '24px',
                    border: '1px solid #e5e7eb',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      textAlign: 'center',
                      gap: '16px',
                    }}
                  >
                    <div
                      style={{
                        width: '96px',
                        height: '96px',
                        borderRadius: '50%',
                        background: 'linear-gradient(to bottom right, #7f5af0, #fba229)',
                      }}
                    />
                    <div>
                      <h4 style={{ fontWeight: '700', fontSize: '1.125rem', color: '#111827' }}>Sarah Mitchell</h4>
                      <p style={{ color: '#888888' }}>UX Designer</p>
                    </div>
                  </div>

                  <div style={{ height: '1px', background: '#e5e7eb', margin: '16px 0' }} />

                  <div style={{ fontSize: '0.875rem', color: '#888888', lineHeight: 1.5 }}>
                    <p>📧 sarah@design.studio</p>
                    <p>📱 +1 (555) 234-5678</p>
                    <p>🌐 sarahmitchell.com</p>
                    <p>📍 San Francisco, CA</p>
                  </div>

                  <div style={{ paddingTop: '16px', textAlign: 'center' }}>
                    <div
                      style={{
                        width: '128px',
                        height: '128px',
                        margin: '0 auto',
                        backgroundColor: '#fff',
                        borderRadius: '12px',
                        padding: '8px',
                      }}
                    >
                      <div
                        style={{
                          width: '100%',
                          height: '100%',
                          borderRadius: '12px',
                          background: 'linear-gradient(to bottom right, #1f2937, #4b5563)',
                        }}
                      />
                    </div>
                    <p style={{ fontSize: '0.75rem', marginTop: '8px', color: '#888888' }}>Scan to connect</p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Horizontal Card */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ delay: 0.4, duration: 0.8 }}
            whileHover={{ scale: 1.05, rotateY: -5 }}
            style={{ transformStyle: 'preserve-3d' }}
          >
            <div
              style={{
                position: 'relative',
                borderRadius: '24px',
                overflow: 'hidden',
                border: '1px solid #e5e7eb',
                boxShadow: '0 25px 50px rgba(0,0,0,0.1)',
                background: 'linear-gradient(to bottom right, #f8fafc, #e5e7eb)',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(to bottom right, rgba(127,90,240,0.1), rgba(251,162,41,0.1))',
                  opacity: 0,
                  transition: 'opacity 0.3s',
                }}
              />
              <div style={{ padding: '32px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
                  <Monitor style={{ width: '24px', height: '24px', color: '#fba229' }} />
                  <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#111827' }}>Horizontal Card</h3>
                </div>

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '24px',
                    backgroundColor: 'rgba(255,255,255,0.5)',
                    backdropFilter: 'blur(4px)',
                    borderRadius: '16px',
                    padding: '24px',
                    border: '1px solid #e5e7eb',
                  }}
                >
                  <div
                    style={{
                      width: '96px',
                      height: '96px',
                      borderRadius: '50%',
                      background: 'linear-gradient(to bottom right, #fba229, #22d3ee)',
                      flexShrink: 0,
                    }}
                  />

                  <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div>
                      <h4 style={{ fontWeight: '700', fontSize: '1.125rem', color: '#111827' }}>Michael Chen</h4>
                      <p style={{ color: '#888888' }}>Full Stack Developer</p>
                    </div>

                    <div style={{ height: '1px', background: '#e5e7eb' }} />

                    <div style={{ fontSize: '0.875rem', color: '#888888', lineHeight: 1.5 }}>
                      <p>📧 michael@devstudio.io</p>
                      <p>📱 +1 (555) 345-6789</p>
                      <p>🌐 michaelchen.dev</p>
                    </div>
                  </div>

                  <div style={{ flexShrink: 0 }}>
                    <div
                      style={{
                        width: '96px',
                        height: '96px',
                        backgroundColor: '#fff',
                        borderRadius: '12px',
                        padding: '8px',
                      }}
                    >
                      <div
                        style={{
                          width: '100%',
                          height: '100%',
                          borderRadius: '12px',
                          background: 'linear-gradient(to bottom right, #1f2937, #4b5563)',
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* NFC Tap Preview */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.6, duration: 0.8 }}
          style={{ marginTop: '48px', textAlign: 'center' }}
        >
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '16px',
              padding: '16px 32px',
              borderRadius: '9999px',
              border: '1px solid rgba(127,90,240,0.2)',
              background: 'linear-gradient(to right, rgba(127,90,240,0.1), rgba(251,162,41,0.1))',
            }}
          >
            <motion.div
              animate={{ scale: [1, 1.2, 1] }}
              transition={{ duration: 2, repeat: Infinity }}
              style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                background: 'linear-gradient(to bottom right, #7f5af0, #fba229)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <span style={{ fontSize: '1.5rem' }}>📱</span>
            </motion.div>
            <div style={{ textAlign: 'left' }}>
              <p style={{ fontWeight: '600', color: '#111827' }}>Tap to Share</p>
              <p style={{ fontSize: '0.875rem', color: '#888888' }}>NFC enabled for instant connection</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CardModels;
